import styled from 'styled-components';

interface SkeletonContainerProps {
  backgroundColor?: string;
}

export const SkeletonContainer = styled.div<SkeletonContainerProps>`
  display: flex;
  flex-direction: row;
  justify-content: center;
  flex-grow: 1;
  align-items: center;
  height: 8.5rem;

  /* TODO: Refactor to theme context */
  /* background-color: ${props => props.theme.colors.capsuleGreen10}; */
  background-color: ${props => props.backgroundColor};
`;
